import { duration } from '@play-co/components';
import { DateTime } from 'luxon';

/**
 * The date where the champions league feature starts, used to calculate the the bi-weekly cycle.
 * It should be any Monday matching the release of new levels, that happens every 2 weeks
 * So last time we released new levels from this implementation was on 2025-03-31
 */
export const championsLeagueFirstStart = DateTime.fromISO(
  '2025-03-31T00:00:00',
  { zone: 'Asia/Tokyo' },
).toMillis();

/**
 * The duration of the recurring champions league event - every 2 weeks.
 */
export const championsLeagueDuration = duration({ days: 14 });
